import { IElement } from "core-integration/src/store/elements/types";
import { size } from "polished";
import * as React from "react";
import styled from "styled-components";
import Info from "../img/icons/info.svg?react";
import Status from "../img/icons/status.svg?react";

const StyledInfo = styled(Info)`
  ${size(18)}
  display: block;
  margin: auto;

  .box {
    fill: white;
  }

  .icon {
    fill: blue;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

const StyledStatus = styled(Status)<{ copnr: number }>`
  ${size(14)}
  display: block;
  margin: auto;
  color: ${(props) => props.theme.colors.elementStatus[props.copnr].bg};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

interface IProps {
  element: IElement;
}

const ElementStatus: React.FC<IProps> = ({ element }) => {
  const copnr = element.chance_of_playing_next_round as number;
  return element.news ? <StyledStatus copnr={copnr} /> : <StyledInfo />;
};

export default ElementStatus;
